
import {map} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { RestService } from '../../shared/providers/rest.service';
import { Observable } from 'rxjs';
import { ITrade1031InputModel } from '../../shared/models/Trade1031InputModel';
import { IExchangeProperties } from '../../shared/models/ExchangePropertiesOutputModel';
import { IExchangePropertyStatusInputModel, IPortfolioNameInput, IDateTimeModel } from '../../shared/models/ExchangePropertyStatusInputModel';
import { IBrokerInput } from '../../shared/models/BrokerInputModel';
import { IResponseModel } from '../../shared/models/ResponseModel';
import { IExchangeDetailsputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { Exchange1031ViewModel } from '../../shared/models/Exchange1031ViewModel';
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { ExchangeCodeInputModel } from '../../shared/models/ExchangeCodeInputModel';
import { SuggestedProprtiesAndExchange } from '../../suggest-multiple-properties/suggest-multiple-properties.component';

@Injectable({
  providedIn: 'root'
})
export class Trade1031Service extends RestService {

  responseModel = {} as IResponseModel;


  // create new user
  Save1031Trade(Trade1031InputModel: ITrade1031InputModel) {
      console.log(JSON.stringify(Trade1031InputModel));
      let url = "user1031/modify1031Trade/";
      return this.postForEntityObject(url, Trade1031InputModel).pipe(
          map(response => {
              return response;
          }));
  }

  Save1031TradeToUserFlowLog(trade1031InputModel: ITrade1031InputModel) {
      return this.postForEntityObject('property/save1031TradeToUserFlowLog/', trade1031InputModel);
  }

  GetExchangeProperties(ExchangeId: number) {
      let url = "user1031/exchangeproperties/" + ExchangeId;
      return this.GET(url).pipe(map(response => {
          return response;
      }));
  }
  GetPlacedOfferProperties(ExchangeId: number) {
      return this.GET('user1031/GetPlacedOfferProperties/' + ExchangeId);
  }

  GetPortfolioList(ExchangeId: number, UserId: number) {
      let url = "user1031/getPortfolioList/" + ExchangeId + '/' + UserId;
      return this.GET(url).pipe(map(response => {
          return response;
      }));
  }

  ChangeExchangePropertyStatus(StatusInputModel: IExchangePropertyStatusInputModel) {
      let url = "user1031/changeexchangepropertystatus/";
      return this.postForEntityObject(url, StatusInputModel).pipe(map(response => {
          return response;
      }));
  }

  SavePortfolioName(PortfolioNameInput: IPortfolioNameInput) {
      let url = "user1031/saveportfolioname/";
      return this.postForEntityObject<IResponseModel>(url, PortfolioNameInput).pipe(map(response => {
          return response;
      }));
  }

  GetPortfolioNameList(ExchangeId: number) {
      let url = "user1031/getportfolionamelist/" + ExchangeId;
      return this.GET(url).pipe(map(response => {
          return response;
      }));
  }

  SaveDemoDate(date: IDateTimeModel) {
    let url = "user1031/SaveExchangeCurrentDate/";
    return this.postForEntityObject<boolean>(url, date).pipe(map(response => {
      return response;
    }));
  }

  GetExchangeCode(userId: number) {
      let url = "user1031/getexchangecode/" + userId;
      return this.GET(url).pipe(map(response => {
          return response;
      }));
  }

  IsExchangeExist(userid) {
      return this.GET("user1031/IsExchangeExist/" + userid);
  }

  IsDemoEnv() {
    return this.get<boolean>("user1031/IsDemoEnv/");
  }

  GetExchangeCodeByBuyerAndBroker(exchangeCodeInputModel: ExchangeCodeInputModel): Observable<IExchangeCodeOutputModel[]> {
      return this.postForEntityObject('user1031/getExchangeCodeByBuyerAndBroker/', exchangeCodeInputModel);
  }


  // add 1031 broker
  Save1031Broker(BrokerInputModel: IBrokerInput) {
      let url = "user1031/Add1031Broker/";
      return this.postForEntityObject<IResponseModel>(url, BrokerInputModel).pipe(
          map(response => {
              //return response;
              this.responseModel = response;
              return this.responseModel;
          }));
  }

  CreateNewExchange(createNewExchangeInputModel: any) {
    return this.postForEntityObject("user1031/CreateNewExchange/", createNewExchangeInputModel);
  }

  RemoveExchangeProperties(exchangeId, loggedinuserid) {
    let url = "user1031/removeexchangeproperties/" + exchangeId + "/" + loggedinuserid;
      return this.post(url, exchangeId).pipe(map(response => {
          return response;
      }));
  }

  GetExchangeDetails(ExchangeId: number, userid : number) {
    let url = "user1031/getexchange1031details/" + ExchangeId + "/" + userid;
      return this.get<IExchangeDetailsputModel>(url).pipe(map(response => {
          return response;
      }));
  }
  GetExchangeGuid(ExchangeId: number) {
    let url = "user1031/getExchangeGuid/" + ExchangeId;
    return this.get<string>(url).pipe(map(response => {
      return response;
    }));
  }
  GetExchange1031DetailsByGuid(ExchangeGuidId: string, userid: number) {
    let url = "user1031/GetExchange1031DetailsByGuid/" + ExchangeGuidId + "/" + userid;
      return this.get<IExchangeDetailsputModel>(url).pipe(map(response => {
          return response;
      }));
  }


  //// this is for 1031Exchange view page
  // GetAll1031ExchangeDetails(ExchangeId: number) {
  GetAll1031ExchangeDetails(ExchangeId: string) {
      let url = "user1031/getAll1031ExchangeDetails/" + ExchangeId;
      return this.get<Exchange1031ViewModel>(url).pipe(map(response => {
          return response;
      }));
  }

  MovePortfolioGroup(MovePortfolioGroupIModel: any) {
      let url = "user1031/MovePortfolioGroup/";
      return this.postForEntityObject(url, MovePortfolioGroupIModel).pipe(map(response => {
          return response;
      }));
  }


  DeletePortfolioGroup(portfolioNameId: number) {
      return this.GET("user1031/MovePortfolioGroup/" + portfolioNameId);
  }

  Update1031InquiryStatus(ExchangeId: number, Status: number) {
      return this.postForEntityObject("user1031/Update1031InquiryStatus/" + ExchangeId + "/" + Status, '');
  }

  Get1031ExchangeDetailsForEdit(exchangeGuid: any) {
      return this.GET("user1031/Get1031ExchangeDetailsForEdit/" + exchangeGuid);
  }
  GetDashboardData(exchangeGuid: any) {
      return this.GET("user1031/GetDashboardData/" + exchangeGuid);
  }

  SaveExchangeInvite(inputModel) {
      return this.postForEntityObject<IResponseModel>("user1031/SaveExchangeInvite/", inputModel);
  }
  GetExchangeInvitees(exchangeId) {
      return this.GET("user1031/GetExchangeInvitees/" + exchangeId);
  }
  GetExchangeBrokers(exchangeId) {
      return this.GET("user1031/GetExchangeBrokers/" + exchangeId);
  }

  DeleteInviteeFromExchange(id,userid) {
      return this.postForEntityObject<IResponseModel>("user1031/DeleteInviteeFromExchange/" + id + "/" + userid, '');
  }

  ChangeInvitePermission(id, permissionId) {
      return this.postForEntityObject<IResponseModel>("user1031/ChangeInvitePermission/" + id + "/" + permissionId, '');
  }

  saveBrokerDetails(brokerDetails, currentExchangeid, loggedinUserId) {
    return this.postForEntityObject<IResponseModel>("user1031/saveBrokerDetails/" + currentExchangeid + "/" + loggedinUserId, brokerDetails);
  }
  SaveExchangeAssociate(inputModel) {
      return this.postForEntityObject<IResponseModel>("user1031/SaveExchangeAssociate/", inputModel);
  }

  UpdateExchangePropertyRating(ExchangePropertyId: number, Rating: number, UserId : number) {
      return this.postForEntityObject("user1031/UpdateExchangePropertyRating/" + ExchangePropertyId + "/" + Rating + "/" + UserId, '');
  }

  changeExchangeInquiryStatus(statusId: number, inquiryId: number) {
      return this.post('opportunity/changeExchangeInquiryStatus/' + statusId + '/' + inquiryId, '');
  }

  SendLinkToEBRA(userId: number) {
      return this.postForEntityObject('user/SendLinkToEBRA/', userId);
  }

  Create1031Inquiry(inputModel: any) {
      return this.postForEntityObject('user/Create1031Inquiry/', inputModel);
  }

  SuggestBulkProperties(suggestionLst: SuggestedProprtiesAndExchange[]) {
    return this.postForEntityObject('user1031/SuggestMultipleProperties', suggestionLst);
  }
}
